import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select, { StylesConfig, components } from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../common/Loader';
import { ShowToast } from '../../../common/Toastr';
import fetchAPI from '../../../common/fetchAPI';
import { useAppSelector } from '../../../app/hooks';
import { dropDownSelectionStyles } from '../../../common/timeLiveFunction';

const objQBExportInitial = [
   { "id": 1, "entitiy": "Clients", "description": "Transfer Timelive Client into QuickBooks Customer / Quickbooks Vendor.", "isExport": false },
   { "id": 2, "entitiy": "Employees", "description": "Transfer Timelive Employee into QuickBooks Employee.", "isExport": false },
   { "id": 3, "entitiy": "Employees", "description": "Transfer Timelive Employee into QuickBooks Employee.", "isExport": false },
   { "id": 4, "entitiy": "Vendors", "description": "If you have Vendors that work for you as a contractors, and also want to track their time for export to QuickBooks, check this box. This will export vendor from TimeLive into QuickBooks.", "isExport": false },
   { "id": 5, "entitiy": "Project/Task", "description": "Transfer Timelive Project/Task into QuickBooks Job/Sub-Job.", "isExport": false },
   { "id": 6, "entitiy": "Project/Task", "description": "Transfer Timelive Project/Task into QuickBooks Job/Sub-Job.", "isExport": false },
   { "id": 7, "entitiy": "Invoice", "description": "Transfer Timelive invoices into QuickBooks sales invoices.", "isExport": false },
   { "id": 8, "entitiy": "Accounts", "description": "Transfer Timelive Expense Codes into QuickBooks Account.", "isExport": false },
   { "id": 9, "entitiy": "Time Entries", "description": "Transfer Timelive Time Entries into QuickBooks Time Activity.", "isExport": false },
   { "id": 10, "entitiy": "Time Entries", "description": "Transfer Timelive Time Entries into QuickBooks Time Activity.", "isExport": false },
   { "id": 11, "entitiy": "Expense Entries", "description": "Transfer Timelive Expense Entries into QuickBooks Bill.", "isExport": false },
   { "id": 12, "entitiy": "Expense Entries", "description": "Transfer Timelive Expense Entries into QuickBooks Bill.", "isExport": false }
]

const objQBImportInitial = [
   { "id": 1, "entitiy": "Customers", "description": "Transfer QuickBooks Customer into TimeLive Client.", "isImport": false },
   { "id": 2, "entitiy": "Employees", "description": "Transfer QuickBooks Employee into TimeLive Employee.", "isImport": false },
   { "id": 3, "entitiy": "Vendors", "description": "If you have Vendors that work for you as a contractors, and also want to track their time for export to QuickBooks, check this box. This will export vendor from QuickBooks into TimeLive.", "isImport": false },
   { "id": 4, "entitiy": "Vendors", "description": "If you have Vendors that work for you as a contractors, and also want to track their time for export to QuickBooks, check this box. This will export vendor from QuickBooks into TimeLive.", "isImport": false },
   { "id": 5, "entitiy": "Job / Sub-Job", "description": "Transfer QuickBooks Job/Sub-Job into Timelive Project/Task.", "isImport": false },
   { "id": 6, "entitiy": "Job / Sub-Job", "description": "Transfer QuickBooks Job/Sub-Job into Timelive Project/Task.", "isImport": false }
]

const objValues = {
   clientValue: 'Customer',
   projectTaskValue: 'JobItem',
   timeEntryEmployeeId: 0,
   timeEntryFromDate: new Date(),
   timeEntryUptoDate: new Date(),
   timeEntryValue: 'Job',
   expenseEntryEmployeeId: 0,
   accountClientId: 0,
   expenseEntryValue: 'Vendor',
   expenseEntryFromDate: new Date(),
   expenseEntryUptoDate: new Date(),
   accountEmployeeList: [],
   expenseEmployeeList: [],
   accountClientList: [],
   isLoading: true,
   // importVendor: 'Employee',
   // importJob: 'Service'
   importVendor: '',
   importJob: ''
}

export const AccountQBOnline = () => {
   const [tab, setTab] = useState('Export');
   const [exportQB, setExportQB] = useState(objQBExportInitial);
   const [importQB, setImportQB] = useState(objQBImportInitial);
   const [values, setValues] = useState<any | ''>(objValues);
   const { t } = useTranslation();
   const { sessionAccountId, sessionAccountEmployeeId, maxMenuHeight, CurrentCultureDateFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
   const navigate = useNavigate();

   useEffect(() => {
      getQBData();
   }, []);

   const onChangeExportQB = (event: any, id: number) => {
      const { checked } = event.target;
      const updatedQB = exportQB.map((item) => {
         if (item.id === id) {
            return { ...item, isExport: checked };
         }
         return item;
      });
      setExportQB(updatedQB);
   }

   const onChangeImportQB = (event: any, id: number) => {
      const { checked } = event.target;
      const updatedImportQB = importQB.map((item) => {
         if (item.id === id) {
            return { ...item, isImport: checked };
         }
         return item;
      });
      setImportQB(updatedImportQB);
   }

   const onHandleExportQBData = () => {
      let teamArray: any[] = [];
      exportQB.map((item) => {
         if (item.isExport) {
            if (item.entitiy === 'Clients') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isExport, "clientValue": values.clientValue
               });
            } else if (item.entitiy === 'Project/Task') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isExport, "projectTaskValue": values.projectTaskValue
               });
            } else if (item.entitiy === 'Time Entries') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isExport, "timeEntryEmployeeId": values.timeEntryEmployeeId,
                  "timeEntryFromDate": values.timeEntryFromDate, "timeEntryUptoDate": values.timeEntryUptoDate, "timeEntryValue": values.timeEntryValue
               });
            } else if (item.entitiy === 'Expense Entries') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isExport, "expenseEntryEmployeeId": values.expenseEntryEmployeeId,
                  "expenseEntryFromDate": values.expenseEntryFromDate, "expenseEntryUptoDate": values.expenseEntryUptoDate,
                  "expenseEntryValue": values.expenseEntryValue, "accountClientId": values.accountClientId
               });
            } else {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isExport
               });
            }
         }
      });
      if (teamArray.length > 0) {
         setValues({
            ...values,
            isLoading: true
         });
         exportQBData(teamArray);
      }
   }

   const onHandleImportQBData = () => {
      let teamArray: any[] = [];
      importQB.map((item) => {
         if (item.isImport) {
            if (item.entitiy === 'Vendors') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isImport, "importVendor": values.importVendor
               });
            } else if (item.entitiy === 'Job / Sub-Job') {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isImport, "importJob": values.importJob
               });
            } else {
               teamArray.push({
                  "entitiy": item.entitiy, "isExport": item.isImport
               });
            }
         }
      });
      if (teamArray.length > 0) {
         setValues({
            ...values,
            isLoading: true
         });
         importQBData(teamArray);
      }
   }

   const exportQBData = async (data: any) => {
      try {
         const response: any = await fetchAPI(`api/v2/Integrations/${sessionAccountId}`, "POST", data, true);
         const json = await response.json();
         if (json.hasOwnProperty('ResponseMessage')) {
            ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
         } else {
            ShowToast('Error', json.message, "error", "toast-top-right");
         }
      } catch (error) {
      } finally {
         setValues({
            ...values,
            isLoading: false
         });
      }
   }

   const importQBData = async (data: any) => {
      try {
         const response: any = await fetchAPI(`api/v2/Integrations/Import/${sessionAccountId}/${sessionAccountEmployeeId}`, "POST", data, true);
         const json = await response.json();
         if (json.hasOwnProperty('ResponseMessage')) {
            ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
         } else {
            ShowToast('Error', json.message, "error", "toast-top-right");
         }
      } catch (error) {
      } finally {
         setValues({
            ...values,
            isLoading: false
         });
      }
   }

   const getQBData = async () => {
      try {
         const response: any = await fetchAPI(`api/v2/Integrations/QB/GetAccountEmployeeForQB/${sessionAccountId}`, "GET", "", true);
         const json = await response.json();
         let tempExpenseArray: any[] = [];
         json["AccountEmployee"].length > 0 && json["AccountEmployee"].map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.FullName;
            if (item.IsVendor) {
               tempExpenseArray.push({ "value": item.AccountEmployeeId, "label": item.FullName });
            }
            delete item.AccountEmployeeId;
            delete item.FullName;
            delete item.IsVendor;
         });
         json["AccountClient"].length > 0 && json["AccountClient"].map((item: any) => {
            item.value = item.AccountClientId;
            item.label = item.ClientName;
            delete item.AccountClientId;
            delete item.ClientName;
         });
         setValues({
            ...values,
            accountEmployeeList: json["AccountEmployee"].length > 0 ? json["AccountEmployee"] : [],
            expenseEmployeeList: tempExpenseArray.length > 0 ? tempExpenseArray : [],
            accountClientList: json["AccountClient"].length > 0 ? json["AccountClient"] : [],
            timeEntryEmployeeId: Number(sessionAccountEmployeeId),
            //expenseEntryEmployeeId: Number(sessionAccountEmployeeId)
            expenseEntryEmployeeId: tempExpenseArray.length > 0 ? tempExpenseArray[0].value : 0,
            accountClientId: json["AccountClient"].length > 0 ? json["AccountClient"][0].value : 0,
            isLoading: false
         });
      } catch (error) {
      } finally {

      }
   }

   const setRadioButtonValue = (e: any) => {
      setValues({ ...values, [e.target.name]: e.target.value })
   }

   const onDateChange = (date: any, keyName: any) => {
      setValues({ ...values, [keyName]: date })
   }

   const onChange = (data: any, keyName: any) => {
      setValues((values: any) => ({
         ...values,
         timeEntryEmployeeId: keyName == "TimeEntryArray" ? values.accountEmployeeList.filter((x: any) => x.value == data.value)[0].value : values.timeEntryEmployeeId,
         expenseEntryEmployeeId: keyName == "ExpenseEntryArray" ? values.expenseEmployeeList.filter((x: any) => x.value == data.value)[0].value : values.expenseEntryEmployeeId,
         accountClientId: keyName == "AccountClientArray" ? values.accountClientList.filter((x: any) => x.value == data.value)[0].value : values.accountClientId
      }));
   }

   return (
      <>
         {values.isLoading && <Loader />}
         <div className="card card-custom admin-card">
            <div className="card-header sticky-top bg-white">
               <h3 className="card-title fw-bold headerTitle">{t('QuickBooks Online Integration')}</h3>
               <div className="card-toolbar align-items-center">
                  <div>
                     <span>{t("Status: ")}</span><span style={{ color: 'green' }}>{t("Connected")}</span>
                  </div>
                  <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                  <a
                     className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                     data-tooltip-id="tooltip-Description"
                     data-tooltip-content={t("View log report")}
                     data-tooltip-place="bottom"
                     onClick={() => {
                        navigate('/accountQBlog')
                     }}>
                     <i className="bi bi-file-text fs-3 iconColor"></i>
                  </a>
                  <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                  <div className='d-flex align-items-center'>
                     <div className='d-flex align-items-center gap-2 gap-lg-3'>
                        <a
                           onClick={() => { tab === 'Export' ? onHandleExportQBData() : onHandleImportQBData() }}
                           className="btn btn-primary btn-sm ">
                           <i className={"fs-5 me-1" + (tab === 'Export' ? 'bi bi-upload' : 'bi bi-download')} style={{ marginBottom: 1 }}></i>{tab === 'Export' ? t('Export') : t('Import')}
                        </a>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card-body py-3">
               <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                  <li className='nav-item'>
                     <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Export' })}
                        onClick={() => setTab('Export')}
                        role='tab'
                        style={{ fontWeight: 500 }}
                     >
                        {t("Export TimeLive to QuickBooks")}
                     </a>
                  </li>
                  <li className='nav-item'>
                     <a
                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'Import' })}
                        onClick={() => setTab('Import')}
                        role='tab'
                        style={{ fontWeight: 500 }}
                     >
                        {t("Import QuickBooks to TimeLive")}
                     </a>
                  </li>
               </ul>
               <div className='tab-content pt-0'>
                  <div className={clsx('tab-pane', { active: tab === 'Export' })}>
                     <div className="table-responsive" style={{ marginTop: 8 }}>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                           <thead>
                              <tr className='thHeading align-middle'>
                                 <th style={{ width: '25%' }}>{t("Entity")}</th>
                                 <th style={{ width: '65%' }}>{t("Description")}</th>
                                 <th style={{ width: '10%' }}></th>
                              </tr>
                           </thead>
                           <tbody>
                              {exportQB.length > 0 && exportQB.map((item: any) => {
                                 if ((item.id === 2 && !exportQB[0].isExport) || (item.id === 6 && !exportQB[4].isExport) || (item.id === 10 && !exportQB[8].isExport) || (item.id === 12 && !exportQB[10].isExport)) {
                                    return null;
                                 }
                                 return (
                                    <tr key={item.id} className={"tdHeight"}>
                                       {item.id != 2 && item.id != 6 && item.id != 10 && item.id != 12 && <>
                                          <td>
                                             <a className='text-dark fw-bold d-block cursor'>
                                                {item.entitiy}
                                             </a>
                                          </td>
                                          <td>
                                             <a className='text-gray-800 d-block'>
                                                {item.description}
                                             </a>
                                          </td>
                                          <td className="tdHeight">
                                             <div className="form-check form-switch form-check-custom">
                                                <input
                                                   type="checkbox"
                                                   className="form-check-input custom-padding-right h-15px w-30px"
                                                   checked={item.isExport ? true : false}
                                                   onChange={(e) => {
                                                      onChangeExportQB(e, item.id)
                                                   }}
                                                />
                                             </div>
                                          </td>
                                       </>}
                                       {(item.id === 2 && exportQB[0].isExport) && (
                                          <td>
                                             <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                <input
                                                   className="form-check-input"
                                                   type="radio"
                                                   value="Customer"
                                                   name="clientValue"
                                                   checked={values.clientValue === 'Customer'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Quickbooks Customer')}
                                                </label>
                                                <input
                                                   className="form-check-input ms-2"
                                                   type="radio"
                                                   value="Vendor"
                                                   name="clientValue"
                                                   checked={values.clientValue === 'Vendor'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Quickbooks Vendor')}
                                                </label>
                                             </div>
                                          </td>
                                       )}
                                       {item.id === 6 && exportQB[4].isExport && (
                                          <td>
                                             <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                <input
                                                   className="form-check-input"
                                                   type="radio"
                                                   value="JobItem"
                                                   name="projectTaskValue"
                                                   checked={values.projectTaskValue === 'JobItem'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Job / Sub-Job')}
                                                </label>
                                                <input
                                                   className="form-check-input ms-2"
                                                   type="radio"
                                                   value="ProductService"
                                                   name="projectTaskValue"
                                                   checked={values.projectTaskValue === 'ProductService'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Category / Product')}
                                                </label>
                                             </div>
                                          </td>
                                       )}
                                       {item.id === 10 && exportQB[8].isExport && (
                                          <>
                                             <td style={{ height: 80 }}>
                                                <label className="form-label fs-7 fw-normal mb-2">{t('Employee Name')}</label>
                                                <Select
                                                   value={values.accountEmployeeList.filter((x: any) => x.value == values.timeEntryEmployeeId)}
                                                   className="basic-single fs-7 fw-normal"
                                                   classNamePrefix="select"
                                                   onChange={(e, name) => onChange(e, "TimeEntryArray")}
                                                   options={values.accountEmployeeList}
                                                   styles={dropDownSelectionStyles}
                                                   maxMenuHeight={maxMenuHeight}
                                                />
                                             </td>
                                             <td>
                                                <div className='row'>
                                                   <div className="col-md-2">
                                                      <label className="form-label fs-7 fw-normal mb-2">{t('Start Date')}</label>
                                                      <div className="wrapper">
                                                         <DatePicker
                                                            selected={values.timeEntryFromDate}
                                                            onChange={(date) => { onDateChange(date, "timeEntryFromDate") }}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                         >
                                                         </DatePicker>
                                                         <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                      </div>
                                                   </div>
                                                   <div className="col-md-2">
                                                      <label className="form-label fs-7 fw-normal mb-2">{t('End Date')}</label>
                                                      <div className="wrapper">
                                                         <DatePicker
                                                            selected={values.timeEntryUptoDate}
                                                            onChange={(date) => onDateChange(date, "timeEntryUptoDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                         >
                                                         </DatePicker>
                                                         <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                      </div>
                                                   </div>
                                                   <div className="col-md-8 mt-10">
                                                      <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                         <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value="Job"
                                                            name="timeEntryValue"
                                                            checked={values.timeEntryValue === 'Job'}
                                                            onChange={(e) => setRadioButtonValue(e)}
                                                         />
                                                         <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                            {t('Job / Sub-Job')}
                                                         </label>
                                                         <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value="JobItem"
                                                            name="timeEntryValue"
                                                            checked={values.timeEntryValue === 'JobItem'}
                                                            onChange={(e) => setRadioButtonValue(e)}
                                                         />
                                                         <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                            {t('Jobs/Items')}
                                                         </label>
                                                         <input
                                                            className="form-check-input ms-8"
                                                            type="radio"
                                                            value="SubItem"
                                                            name="timeEntryValue"
                                                            checked={values.timeEntryValue === 'SubItem'}
                                                            onChange={(e) => setRadioButtonValue(e)}
                                                         />
                                                         <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                            {t('Item / Sub-Item')}
                                                         </label>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </>
                                       )}
                                       {item.id === 12 && exportQB[10].isExport && (
                                          <>
                                             <td style={{ height: 80 }}>
                                                <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                   <input
                                                      className="form-check-input"
                                                      type="radio"
                                                      value="Vendor"
                                                      name="expenseEntryValue"
                                                      checked={values.expenseEntryValue === 'Vendor'}
                                                      onChange={(e) => setRadioButtonValue(e)}
                                                   />
                                                   <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                      {t('Vendor')}
                                                   </label>
                                                   <input
                                                      className="form-check-input ms-2"
                                                      type="radio"
                                                      value="Client"
                                                      name="expenseEntryValue"
                                                      checked={values.expenseEntryValue === 'Client'}
                                                      onChange={(e) => setRadioButtonValue(e)}
                                                   />
                                                   <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                      {t('Client')}
                                                   </label>
                                                </div>
                                             </td>
                                             <td>
                                                <div className='row'>
                                                   <div className="col-md-4">
                                                      {values.expenseEntryValue === 'Vendor' && <>
                                                         <label className="form-label fs-7 fw-normal mb-2">{t('Employee Name')}</label>
                                                         <Select
                                                            value={values.expenseEmployeeList.filter((x: any) => x.value == values.expenseEntryEmployeeId)}
                                                            className="basic-single fs-7 fw-normal"
                                                            classNamePrefix="select"
                                                            onChange={(e, name) => onChange(e, "ExpenseEntryArray")}
                                                            options={values.expenseEmployeeList}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                         /></>
                                                      }
                                                      {values.expenseEntryValue === 'Client' && <>
                                                         <label className="form-label fs-7 fw-normal mb-2">{t('Clients')}</label>
                                                         <Select
                                                            value={values.accountClientList.filter((x: any) => x.value == values.accountClientId)}
                                                            className="basic-single fs-7 fw-normal"
                                                            classNamePrefix="select"
                                                            onChange={(e, name) => onChange(e, "AccountClientArray")}
                                                            options={values.accountClientList}
                                                            styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight}
                                                         />
                                                      </>}
                                                   </div>
                                                   <div className="col-md-2">
                                                      <label className="form-label fs-7 fw-normal mb-2">{t('Start Date')}</label>
                                                      <div className="wrapper">
                                                         <DatePicker
                                                            selected={values.expenseEntryFromDate}
                                                            onChange={(date) => onDateChange(date, "expenseEntryFromDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                         >
                                                         </DatePicker>
                                                         <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                      </div>
                                                   </div>
                                                   <div className="col-md-2">
                                                      <label className="form-label fs-7 fw-normal mb-2">{t('End Date')}</label>
                                                      <div className="wrapper">
                                                         <DatePicker
                                                            selected={values.expenseEntryUptoDate}
                                                            onChange={(date) => onDateChange(date, "expenseEntryUptoDate")}
                                                            calendarStartDay={calendarStartDay}
                                                            className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                         >
                                                         </DatePicker>
                                                         <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                      </div>
                                                   </div>
                                                </div>
                                             </td>
                                          </>
                                       )}
                                    </tr>
                                 )
                              })}
                           </tbody>
                        </table>
                        {/* <div className='d-flex flex-end'>
                           <button
                              className='btn btn-sm btn-primary'
                              type='button'
                              data-kt-element='send'
                              onClick={() => onHandleExportQBData()}
                           >
                              {t('Export')}
                           </button>
                        </div> */}
                     </div>
                  </div>
                  <div className={clsx('tab-pane', { active: tab === 'Import' })}>
                     <div className="table-responsive" style={{ marginTop: 8 }}>
                        <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                           <thead>
                              <tr className='thHeading align-middle'>
                                 <th style={{ width: '25%' }}>{t("Entity")}</th>
                                 <th style={{ width: '65%' }}>{t("Description")}</th>
                                 <th style={{ width: '10%' }}></th>
                              </tr>
                           </thead>
                           <tbody>
                              {importQB.length > 0 && importQB.map((item: any) => {
                                 if ((item.id === 4 && !importQB[2].isImport) || (item.id === 6 && !importQB[4].isImport)) {
                                    return null;
                                 }
                                 return (
                                    <tr key={item.id} className={"tdHeight"}>
                                       {item.id != 4 && item.id != 6 && <>
                                          <td>
                                             <a className='text-dark fw-bold d-block cursor'>
                                                {item.entitiy}
                                             </a>
                                          </td>
                                          <td>
                                             <a className='text-gray-800 d-block'>
                                                {item.description}
                                             </a>
                                          </td>
                                          <td className="tdHeight">
                                             <div className="form-check form-switch form-check-custom">
                                                <input
                                                   type="checkbox"
                                                   className="form-check-input custom-padding-right h-15px w-30px"
                                                   checked={item.isImport ? true : false}
                                                   onChange={(e) => {
                                                      onChangeImportQB(e, item.id)
                                                   }}
                                                />
                                             </div>
                                          </td>
                                       </>}
                                       {(item.id === 4 && importQB[2].isImport) && (
                                          <td>
                                             <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                <input
                                                   className="form-check-input"
                                                   type="radio"
                                                   value="Employee"
                                                   name="importVendor"
                                                   checked={values.importVendor === 'Employee'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Vendor as Employee')}
                                                </label>
                                                <input
                                                   className="form-check-input ms-2"
                                                   type="radio"
                                                   value="Client"
                                                   name="importVendor"
                                                   checked={values.importVendor === 'Client'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Vendor as Client')}
                                                </label>
                                             </div>
                                          </td>
                                       )}
                                       {(item.id === 6 && importQB[4].isImport) && (
                                          <td>
                                             <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                <input
                                                   className="form-check-input"
                                                   type="radio"
                                                   value="Job"
                                                   name="importJob"
                                                   checked={values.importJob === 'Job'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label" style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Job / Sub-Job')}
                                                </label>
                                                <input
                                                   className="form-check-input ms-2"
                                                   type="radio"
                                                   value="Item"
                                                   name="importJob"
                                                   checked={values.importJob === 'Item'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Item / Sub-Item')}
                                                </label>
                                                <input
                                                   className="form-check-input ms-2"
                                                   type="radio"
                                                   value="Service"
                                                   name="importJob"
                                                   checked={values.importJob === 'Service'}
                                                   onChange={(e) => setRadioButtonValue(e)}
                                                />
                                                <label className="form-check-label " style={{ color: '#3f4254', fontWeight: 500 }}>
                                                   {t('Category / Service')}
                                                </label>
                                             </div>
                                          </td>
                                       )}
                                    </tr>
                                 )
                              })}
                           </tbody>
                        </table>
                        {/* <div className='d-flex flex-end'>
                           <button
                              className='btn btn-sm btn-primary'
                              type='button'
                              data-kt-element='send'
                              onClick={() => onHandleImportQBData()}
                           >
                              {t('Import')}
                           </button>
                        </div> */}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}